import { httpsCallable } from 'firebase/functions'
import { getAuth } from 'firebase/auth'
import { functions } from '@/firebase'
import { createCloudReportQueue } from './cloudReportQueue'

export function createSmokeCloudReport(onStatus) {
  const startingUid = getAuth().currentUser?.uid
  const save = httpsCallable(functions, 'saveSmokeReport', { timeout: 30000 })
  return createCloudReportQueue({
    onStatus,
    async send(checkpoint) {
      if (import.meta.env.VITE_FIREBASE_PROJECT_ID !== 'casemangervue')
        throw new Error('Cloud smoke reports are available on hosted dev only.')
      if (!startingUid || getAuth().currentUser?.uid !== startingUid)
        throw new Error('Account changed. Cloud report was not saved.')
      return (await save(checkpoint)).data
    }
  })
}
